module.exports = __webpack_public_path__ + "static/media/faq-960.68d296f0.jpg";